import React from "react";
import { ChevronLeft, ChevronRight } from "react-bootstrap-icons"; // Optional icons
 
const Pagination = ({ page, totalPages, hasPrev, hasNext, onPageChange, totalDocs }) => {
  const maxPagesToShow = 5;
 
  let startPage = Math.max(1, page - Math.floor(maxPagesToShow / 2));
  let endPage = startPage + maxPagesToShow - 1;
 
  if (endPage > totalPages) {
    endPage = totalPages;
    startPage = Math.max(1, endPage - maxPagesToShow + 1);
  }
 
  const pages = [];
  for (let i = startPage; i <= endPage; i++) {
    pages.push(i);
  }
 
  return (
    <div className="d-flex justify-content-between align-items-center mt-3 gap-3 flex-wrap">
    <div className="user-select-none">
      Page {page} of {totalPages} — Total {totalDocs} records
    </div>
    <nav aria-label="Pagination">
      <ul className="pagination justify-content-center flex-wrap gap-1 mb-0 user-select-none">
        {/* Previous */}
        <li className={`page-item ${!hasPrev ? "disabled" : ""}`}>
          <button
            className="page-link d-flex align-items-center justify-content-center"
            disabled={!hasPrev}
            onClick={(e) => {e.preventDefault();hasPrev && onPageChange(page - 1)}}
          >
            <ChevronLeft className="me-1" /> Prev
          </button>
        </li>
        {/* First Page */}
        {startPage > 1 && (
          <>
            <li className="page-item">
              <button className="page-link" onClick={(e) => {e.preventDefault();onPageChange(1)}}>
                1
              </button>
            </li>
            {startPage > 2 && (
              <li className="page-item disabled">
                <span className="page-link">...</span>
              </li>
            )}
          </>
        )}
 
        {/* Middle Pages */}
        {pages.map((p) => (
          <li
            key={p}
            className={`page-item ${page === p ? "active" : ""}`}
          >
            <button
              className="page-link"
              onClick={(e) => {
                e.preventDefault();
                onPageChange(p)}
              }
              aria-current={page === p ? "page" : undefined}
            >
              {p}
            </button>
          </li>
        ))}
 
        {/* Last Page */}
        {endPage < totalPages && (
          <>
            {endPage < totalPages - 1 && (
              <li className="page-item disabled">
                <span className="page-link">...</span>
              </li>
            )}
            <li className="page-item">
              <button
                className="page-link"
                onClick={(e) => {
                  e.preventDefault();
                  onPageChange(totalPages)}
                }
              >
                {totalPages}
              </button>
            </li>
          </>
        )}
 
        {/* Next */}
        <li className={`page-item ${!hasNext ? "disabled" : ""}`}>
          <button
            className="page-link d-flex align-items-center justify-content-center"
            disabled={!hasNext}
            onClick={(e) => {e.preventDefault();hasNext && onPageChange(page + 1)}}
          >
            Next <ChevronRight className="ms-1" />
          </button>
        </li>
      </ul>
    </nav>
    </div>
  );
};
 
export default Pagination;